import moment from "moment";
import readXlsxFile from "read-excel-file";

//Nomes de coluna aceitos no cabeçalho do arquivo (pt e en, com e sem acento).
//Assim a unidade pode montar a planilha do jeito que preferir.
const COLUNAS = {
    description: ["descricao","description","feriado","recesso","nome","name","motivo","evento","titulo"],
    startDate: ["inicio","start","startdate","data","datainicio","datainicial","datadeinicio","de","dia"],
    endDate: ["fim","end","enddate","datafim","datafinal","datadefim","ate","final","a"]
};

//tira acento, espaço e pontuação para comparar nome de coluna
export function normalizeKey(text){

    if(text === undefined || text === null){ return ""; }

    return String(text)
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[^a-z0-9]/g,"");

}

//Converte o que vier (Date do xlsx, serial do Excel, AAAA-MM-DD, DD/MM/AAAA) em AAAA-MM-DD.
//Devolve "" quando está vazio e null quando não deu para entender a data.
export function normalizeDate(value){

    if(value === undefined || value === null){ return ""; }

    if(value instanceof Date){

        if(isNaN(value.getTime())){ return null; }
        //a lib de xlsx entrega meia-noite UTC: lendo em UTC a data do calendario nao desloca
        return moment.utc(value).format("YYYY-MM-DD");

    }

    //número puro em planilha é o serial de data do Excel (base 30/12/1899)
    if(typeof value === "number"){

        if(!isFinite(value) || value <= 0){ return null; }
        return moment.utc("1899-12-30","YYYY-MM-DD").add(Math.round(value),"day").format("YYYY-MM-DD");

    }

    var texto = String(value).trim();
    if(texto === ""){ return ""; }

    var formatos = ["YYYY-MM-DD","DD/MM/YYYY","DD-MM-YYYY","YYYY/MM/DD","D/M/YYYY","YYYY-M-D"];

    for(let index = 0; index < formatos.length; index++){

        var data = moment(texto,formatos[index],true);
        if(data.isValid()){ return data.format("YYYY-MM-DD"); }

    }

    //data com hora (ISO vindo de export de sistema)
    var iso = moment.utc(texto,moment.ISO_8601,true);
    if(iso.isValid()){ return iso.format("YYYY-MM-DD"); }

    return null;

}

//Descobre, a partir da primeira linha, qual coluna é qual.
//Sem cabeçalho reconhecível, assume a ordem descrição, início, fim.
export function detectColumns(primeiraLinha){

    var mapa = { description:-1, startDate:-1, endDate:-1, temCabecalho:false };

    if(!Array.isArray(primeiraLinha)){ return mapa; }

    for(let index = 0; index < primeiraLinha.length; index++){

        var chave = normalizeKey(primeiraLinha[index]);
        if(chave === ""){ continue; }

        for(var campo in COLUNAS){

            if(mapa[campo] === -1 && COLUNAS[campo].indexOf(chave) !== -1){

                mapa[campo] = index;
                mapa.temCabecalho = true;
                break;

            }

        }

    }

    //sem cabeçalho: posição fixa
    if(mapa.temCabecalho === false){

        mapa.description = 0;
        mapa.startDate = 1;
        mapa.endDate = 2;

    }

    return mapa;

}

//monta o feriado já normalizado e com o erro da linha, quando tiver
function montaHoliday(description,startDate,endDate){

    var holiday = {
        description: (description === undefined || description === null) ? "" : String(description).trim(),
        startDate: normalizeDate(startDate),
        endDate: normalizeDate(endDate),
        erro: ""
    };

    if(holiday.description === ""){

        holiday.erro = "A descrição não foi informada.";

    }else if(holiday.startDate === null){

        holiday.erro = "A data de início não foi entendida (use AAAA-MM-DD ou DD/MM/AAAA).";

    }else if(holiday.startDate === ""){

        holiday.erro = "A data de início não foi informada.";

    }else if(holiday.endDate === null){

        holiday.erro = "A data de fim não foi entendida (use AAAA-MM-DD ou DD/MM/AAAA).";

    }else if(holiday.endDate !== "" && holiday.endDate < holiday.startDate){

        holiday.erro = "A data de fim é anterior à data de início.";

    }

    //no envio, fim vazio significa feriado de um dia
    if(holiday.startDate === null){ holiday.startDate = ""; }
    if(holiday.endDate === null){ holiday.endDate = ""; }

    return holiday;

}

//Converte linhas (array de arrays) em feriados, marcando o erro de cada linha
export function rowsToHolidays(rows){

    var holidays = [];

    if(!Array.isArray(rows) || rows.length === 0){ return holidays; }

    //ignora linhas totalmente vazias (comuns em planilha)
    var linhas = rows.filter(function(row){

        if(!Array.isArray(row)){ return false; }

        return row.filter(function(celula){

            return celula !== null && celula !== undefined && String(celula).trim() !== "";

        }).length > 0;

    });

    if(linhas.length === 0){ return holidays; }

    var mapa = detectColumns(linhas[0]);
    var inicio = mapa.temCabecalho ? 1 : 0;

    for(let index = inicio; index < linhas.length; index++){

        var linha = linhas[index];

        var description = (mapa.description === -1) ? "" : linha[mapa.description];
        var startDate = (mapa.startDate === -1) ? "" : linha[mapa.startDate];
        var endDate = (mapa.endDate === -1) ? "" : linha[mapa.endDate];

        holidays.push(montaHoliday(description,startDate,endDate));

    }

    return holidays;

}

//JSON: aceita [ ... ], { holidays:[ ... ] } e array de arrays
export function parseJsonText(text){

    var conteudo = JSON.parse(text);

    if(conteudo !== null && !Array.isArray(conteudo) && typeof conteudo === "object"){

        conteudo = conteudo.holidays || conteudo.feriados || conteudo.data;

    }

    if(!Array.isArray(conteudo)){

        throw new Error("O JSON precisa ser uma lista de feriados.");

    }

    //array de arrays cai no mesmo caminho do CSV/XLSX
    if(conteudo.length > 0 && Array.isArray(conteudo[0])){ return rowsToHolidays(conteudo); }

    return conteudo.map(function(item){

        if(item === null || typeof item !== "object"){ return montaHoliday("","",""); }

        var description = "";
        var startDate = "";
        var endDate = "";

        for(var chaveOriginal in item){

            var chave = normalizeKey(chaveOriginal);

            if(description === "" && COLUNAS.description.indexOf(chave) !== -1){ description = item[chaveOriginal]; }
            if(startDate === "" && COLUNAS.startDate.indexOf(chave) !== -1){ startDate = item[chaveOriginal]; }
            if(endDate === "" && COLUNAS.endDate.indexOf(chave) !== -1){ endDate = item[chaveOriginal]; }

        }

        return montaHoliday(description,startDate,endDate);

    });

}

//Descobre o separador do CSV olhando a primeira linha fora das aspas
export function detectSeparator(text){

    var primeiraLinha = String(text).split(/\r?\n/)[0] || "";
    var candidatos = [";",",","\t"];
    var melhor = ";";
    var maior = -1;

    for(let index = 0; index < candidatos.length; index++){

        var total = 0;
        var dentroDeAspas = false;

        for(let pos = 0; pos < primeiraLinha.length; pos++){

            var caractere = primeiraLinha.charAt(pos);
            if(caractere === String.fromCharCode(34)){ dentroDeAspas = !dentroDeAspas; }
            if(caractere === candidatos[index] && dentroDeAspas === false){ total++; }

        }

        if(total > maior){ maior = total; melhor = candidatos[index]; }

    }

    return melhor;

}

//CSV: vira array de arrays, respeitando campo entre aspas e aspas duplicadas
export function csvToRows(text,separador){

    var ASPAS = String.fromCharCode(34);
    var conteudo = String(text).replace(/^﻿/,"");
    var sep = (separador === undefined) ? detectSeparator(conteudo) : separador;

    var rows = [];
    var campo = "";
    var linha = [];
    var dentroDeAspas = false;

    for(let index = 0; index < conteudo.length; index++){

        var caractere = conteudo.charAt(index);

        if(dentroDeAspas){

            if(caractere === ASPAS){

                if(conteudo.charAt(index + 1) === ASPAS){ campo += ASPAS; index++; }else{ dentroDeAspas = false; }

            }else{

                campo += caractere;

            }

            continue;

        }

        if(caractere === ASPAS){ dentroDeAspas = true; continue; }

        if(caractere === sep){ linha.push(campo); campo = ""; continue; }

        if(caractere === "\n"){

            linha.push(campo);
            rows.push(linha);
            linha = [];
            campo = "";
            continue;

        }

        if(caractere === "\r"){ continue; }

        campo += caractere;

    }

    if(campo !== "" || linha.length > 0){ linha.push(campo); rows.push(linha); }

    return rows;

}

export function parseCsvText(text){

    return rowsToHolidays(csvToRows(text));

}

//Descobre o formato pela extensão do arquivo
export function detectFormat(filename){

    var nome = String(filename || "").toLowerCase();

    if(nome.indexOf(".json",nome.length - 5) !== -1){ return "json"; }
    if(nome.indexOf(".csv",nome.length - 4) !== -1 || nome.indexOf(".txt",nome.length - 4) !== -1 || nome.indexOf(".tsv",nome.length - 4) !== -1){ return "csv"; }
    if(nome.indexOf(".xlsx",nome.length - 5) !== -1 || nome.indexOf(".xlsm",nome.length - 5) !== -1 || nome.indexOf(".xls",nome.length - 4) !== -1){ return "xlsx"; }

    return "";

}

function lerTexto(file){

    return new Promise(function(resolve,reject){

        var leitor = new FileReader();
        leitor.onload = function(){ resolve(leitor.result); };
        leitor.onerror = function(){ reject(new Error("Não foi possível ler o arquivo.")); };
        leitor.readAsText(file,"UTF-8");

    });

}

//Entrada única: recebe o File do input e devolve os feriados já normalizados
export async function parseHolidayFile(file){

    var formato = detectFormat(file.name);

    if(formato === ""){

        throw new Error("Formato não suportado. Use JSON, CSV ou XLSX.");

    }

    if(formato === "xlsx"){

        var rows = await readXlsxFile(file);
        return { formato: formato, holidays: rowsToHolidays(rows) };

    }

    var texto = await lerTexto(file);

    if(formato === "json"){

        return { formato: formato, holidays: parseJsonText(texto) };

    }

    return { formato: formato, holidays: parseCsvText(texto) };

}

//Modelo de arquivo para a unidade baixar e preencher
export function modeloCsv(){

    return "descricao;inicio;fim\n"+
        "Confraternizacao Universal;2027-01-01;\n"+
        "Carnaval;2027-02-08;2027-02-10\n"+
        "Recesso de julho;2027-07-12;2027-07-17\n";

}

export function modeloJson(){

    return JSON.stringify([
        { descricao:"Confraternizacao Universal", inicio:"2027-01-01" },
        { descricao:"Carnaval", inicio:"2027-02-08", fim:"2027-02-10" },
        { descricao:"Recesso de julho", inicio:"2027-07-12", fim:"2027-07-17" }
    ],null,2);

}
